import { render } from "./VaPageNotFound.vue?vue&type=template&id=1a73e56b"
import script from "./VaPageNotFound.vue?vue&type=script&lang=js"
export * from "./VaPageNotFound.vue?vue&type=script&lang=js"

import "./VaPageNotFound.vue?vue&type=style&index=0&id=1a73e56b&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__